/*
 * Rennsieger — Axis page toggle.
 *
 * Both axis panels (Aesthetics / Performance) are in the DOM; the pill you pick shows
 * one and hides the other instantly, like the DRL colour/model filters — no page load.
 * Progressive enhancement: with no JS the pills are real links to the sibling page.
 * The URL is kept in sync (replaceState) so a refresh or share lands on the same tab.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-rsg-axis]');
  if (!root) return;

  var pills = Array.prototype.slice.call(root.querySelectorAll('[data-axis-pill]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-axis-panel]'));
  if (!pills.length || !panels.length) return;

  function hrefFor(axis) {
    for (var i = 0; i < pills.length; i++) {
      if (pills[i].getAttribute('data-axis-pill') === axis) return pills[i].getAttribute('href');
    }
    return null;
  }

  function setAxis(axis, isSwitch) {
    panels.forEach(function (p) {
      var on = p.getAttribute('data-axis-panel') === axis;
      p.classList.toggle('axis-off', !on);
      // A panel that starts hidden never triggered the global scroll-reveal, so reveal it
      // now that it is shown.
      if (on && isSwitch) {
        p.querySelectorAll('.rsg-reveal').forEach(function (el) { el.classList.add('is-in'); });
      }
    });
    pills.forEach(function (b) {
      var on = b.getAttribute('data-axis-pill') === axis;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (isSwitch) {
      var href = hrefFor(axis);
      if (href) { try { history.replaceState(null, '', href); } catch (e) {} }
    }
  }

  // Initial tab: URL hash / ?axis= wins, else the server-rendered default.
  var initial = root.getAttribute('data-default-axis') || 'aesthetics';
  var hash = (location.hash || '').replace('#', '');
  var qp = null;
  try { qp = new URLSearchParams(location.search).get('axis'); } catch (e) {}
  if (hash === 'aesthetics' || hash === 'performance') initial = hash;
  else if (qp === 'aesthetics' || qp === 'performance') initial = qp;
  if (initial !== (root.getAttribute('data-default-axis') || 'aesthetics')) setAxis(initial, true);

  pills.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      setAxis(b.getAttribute('data-axis-pill'), true);
    });
  });
})();
